var _controlsByType, _mapValues;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import mapValues from 'lodash/mapValues';
import { derivePropTypeFromValueOf } from '@signal/prop-types';
import componentPropType from '@signal/prop-types/component';
import FormControlCheckbox, { propTypes as propTypeCheckbox } from '../FormControlCheckbox';
import FormControlDateRange, { propTypes as propTypeDateRange } from '../FormControlDateRange';
import FormControlRadioGroup, { propTypes as propTypeRadioGroup } from '../FormControlRadioGroup';
import FormControlRadioButtonGroup, { propTypes as propTypeRadioButtonGroup } from '../FormControlRadioButtonGroup';
import FormControlSelect, { propTypes as propTypeSelect } from '../FormControlSelect';
import FormControlSwitch, { propTypes as propTypeSwitch } from '../FormControlSwitch';
import FormControlTextField, { propTypes as propTypeText } from '../FormControlTextField';
import FormControlFieldset, { propTypes as propTypeFieldset } from '../FormControlFieldset';
import FormControlCustom, { propTypes as propTypeCustom } from '../FormControlCustom';
import { FORM_CONTROL_TYPES, FORM_CONTROL_TYPE_CHECKBOX, FORM_CONTROL_TYPE_DATE_RANGE, FORM_CONTROL_TYPE_RADIO, FORM_CONTROL_TYPE_RADIO_BUTTONS, FORM_CONTROL_TYPE_SELECT, FORM_CONTROL_TYPE_SWITCH, FORM_CONTROL_TYPE_TEXT, FORM_CONTROL_TYPE_FIELDSET, FORM_CONTROL_TYPE_CUSTOM } from './constants';
import { Wrapper } from './styles';
export * from './constants';
var controlsByType = (_controlsByType = {}, _defineProperty(_controlsByType, FORM_CONTROL_TYPE_TEXT, FormControlTextField), _defineProperty(_controlsByType, FORM_CONTROL_TYPE_CHECKBOX, FormControlCheckbox), _defineProperty(_controlsByType, FORM_CONTROL_TYPE_SWITCH, FormControlSwitch), _defineProperty(_controlsByType, FORM_CONTROL_TYPE_RADIO, FormControlRadioGroup), _defineProperty(_controlsByType, FORM_CONTROL_TYPE_RADIO_BUTTONS, FormControlRadioButtonGroup), _defineProperty(_controlsByType, FORM_CONTROL_TYPE_SELECT, FormControlSelect), _defineProperty(_controlsByType, FORM_CONTROL_TYPE_DATE_RANGE, FormControlDateRange), _defineProperty(_controlsByType, FORM_CONTROL_TYPE_FIELDSET, FormControlFieldset), _defineProperty(_controlsByType, FORM_CONTROL_TYPE_CUSTOM, FormControlCustom), _controlsByType);
var propTypesByType = mapValues((_mapValues = {}, _defineProperty(_mapValues, FORM_CONTROL_TYPE_TEXT, propTypeText), _defineProperty(_mapValues, FORM_CONTROL_TYPE_CHECKBOX, propTypeCheckbox), _defineProperty(_mapValues, FORM_CONTROL_TYPE_SWITCH, propTypeSwitch), _defineProperty(_mapValues, FORM_CONTROL_TYPE_RADIO, propTypeRadioGroup), _defineProperty(_mapValues, FORM_CONTROL_TYPE_RADIO_BUTTONS, propTypeRadioButtonGroup), _defineProperty(_mapValues, FORM_CONTROL_TYPE_SELECT, propTypeSelect), _defineProperty(_mapValues, FORM_CONTROL_TYPE_DATE_RANGE, propTypeDateRange), _defineProperty(_mapValues, FORM_CONTROL_TYPE_FIELDSET, propTypeFieldset), _defineProperty(_mapValues, FORM_CONTROL_TYPE_CUSTOM, propTypeCustom), _mapValues), PropTypes.shape);
export var propTypes = {
  name: PropTypes.string,
  onChange: PropTypes.func,
  attrs: derivePropTypeFromValueOf('type', propTypesByType),
  type: PropTypes.oneOf(FORM_CONTROL_TYPES).isRequired,
  controlWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  component: componentPropType
};
export var defaultProps = {
  controlWidth: 300
};
export var FormControl = /*#__PURE__*/function (_PureComponent) {
  _inherits(FormControl, _PureComponent);

  var _super = _createSuper(FormControl);

  function FormControl() {
    _classCallCheck(this, FormControl);

    return _super.apply(this, arguments);
  }

  _createClass(FormControl, [{
    key: "render",
    value: function render() {
      return FormControl.renderFormControl(this.props);
    }
  }], [{
    key: "renderFormControl",
    value: function renderFormControl(formControl) {
      var _formControl$attrs = formControl.attrs,
          attrs = _formControl$attrs === void 0 ? {} : _formControl$attrs,
          name = formControl.name,
          onChange = formControl.onChange,
          onBlur = formControl.onBlur,
          type = formControl.type,
          style = formControl.style,
          className = formControl.className,
          controlWidth = formControl.controlWidth,
          component = formControl.component;
      var ControlComponent = controlsByType[type];
      if (!ControlComponent) return null;
      return /*#__PURE__*/React.createElement(Wrapper, {
        style: style,
        className: className
      }, /*#__PURE__*/React.createElement(ControlComponent, Object.assign({
        name: name,
        onChange: onChange,
        onBlur: onBlur,
        renderFormControl: FormControl.renderFormControl,
        width: controlWidth,
        component: component
      }, attrs)));
    }
  }]);

  return FormControl;
}(PureComponent);

_defineProperty(FormControl, "propTypes", propTypes);

_defineProperty(FormControl, "defaultProps", defaultProps);

export default FormControl;